import { error, log } from './Log'

const Listrak = {
  lineItemFields: ['sku', 'quantity', 'salePrice', 'name', 'imageUrl', 'url'],
  async submitCart(cart) {
    try {
      cart.lineItems.physicalItems.forEach((item) => {
        _ltk.SCA.AddItemWithLinks(
          item.sku,
          item.quantity,
          item.salePrice,
          item.name,
          item.imageurl,
          item.url
        )
      })
      _ltk.SCA.Submit()
      log('submitted')
    } catch (e) {
      error(`Failed to submit cart to listrak ${e}`)
    }
  },
  listrakProductBrowse(sku) {
    try {
      // eslint-disable-next-line no-undef
      const listrak = window?._ltk
      listrak?.Activity?.AddProductBrowse(sku)
    } catch (e) {
      error(e)
    }
  },
  listrakOrderTracking(
    user, order, lineItems, itemsSubtotal, shippingCost, taxTotal, grandTotal,
  ) {
    try {
      // eslint-disable-next-line no-undef
      const listrak = _ltk
      if (listrak && !!order?.orderId && !!user?.email) {
        listrak.Order.SetCustomer(user.email, user.firstName, user.lastName)
        listrak.Order.OrderNumber = order.orderId
        listrak.Order.ItemTotal = itemsSubtotal
        listrak.Order.ShippingTotal = shippingCost
        listrak.Order.TaxTotal = taxTotal
        listrak.Order.OrderTotal = grandTotal

        lineItems.forEach(({
          sku,
          quantity,
          salePrice,
        }) => {
          listrak.Order.AddItem(sku, quantity, salePrice)
        })

        listrak.Order.Submit()
      }
    } catch (e) {
      error(e)
    }
  },
  listrakEmptyCart() {
    try {
      _ltk.SCA.ClearCart()
    } catch {
    }
  }
}

export default Listrak
